import React from 'react';
import './LevelList.css';
import { useTranslation } from 'react-i18next';

function LevelList({ totalLevels, currentLevel, onSelectLevel, onBack, levelsData, userLang }) {
  const { t } = useTranslation();

  const safeTotalLevels = totalLevels > 0 ? totalLevels : 0;
  const levelsArray = Array.from({ length: safeTotalLevels }, (_, i) => i + 1);
  const ghostLevelsArray = Array.from({ length: 5 }, (_, i) => i + 1);

  return (
    <div className="level-list-container">
      <div className="level-list-header">
        <button className="back-btn" onClick={onBack}>←</button>
        <h2>{t('levels_button')}</h2>
        <div className="spacer"></div>
      </div>

      {/* Container com scroll e máscara de fade */}
      <div className="levels-list-scroll-mask">
        <div className="levels-list-scroll">
            {levelsArray.length === 0 ? (
            <div className="loading-levels">Loading...</div>
            ) : (
            <>
                {/* Níveis Reais */}
                {levelsArray.map((levelNum) => {
                const isLocked = levelNum > currentLevel;
                const isCompleted = levelNum < currentLevel;
                const isCurrent = levelNum === currentLevel;

                const levelKey = `level_${levelNum}`;
                const levelObj = levelsData ? levelsData[levelKey] : null;
                const theme = levelObj?.themes?.[userLang];
                
                let displayText = `Level ${levelNum}`;
                
                if (isLocked) {
                    displayText = `${levelNum} - ???`;
                } else if (theme) {
                    displayText = `${levelNum} - ${theme.toUpperCase()}`;
                } else {
                    displayText = t('level_card_open', { level: levelNum });
                }

                let cardClass = 'level-row-card';
                if (isLocked) cardClass += ' locked';
                if (isCompleted) cardClass += ' completed';
                if (isCurrent) cardClass += ' current';

                return (
                    <button 
                    key={levelNum} 
                    className={cardClass}
                    onClick={() => !isLocked && onSelectLevel(levelNum)}
                    disabled={isLocked}
                    >
                    <div className="level-info-container">
                        <span className="level-main-text">{displayText}</span>
                    </div>
                    
                    <div className="level-icon-container">
                        {isLocked ? '🔒' : (isCompleted ? '⭐' : '▶')}
                    </div>
                    </button>
                );
                })}

                {/* Níveis Fantasmas (Para simular continuidade) */}
                {ghostLevelsArray.map((_, index) => (
                    <div key={`ghost-${index}`} className={`level-row-card locked ghost fade-${index}`}>
                        <div className="level-info-container">
                            <span className="level-main-text">{safeTotalLevels + index + 1} - ???</span>
                        </div>
                        <div className="level-icon-container">
                            🔒
                        </div>
                    </div>
                ))}
                
                {/* Mensagem Final - Agora faz parte do scroll */}
                <div className="list-footer-message">
                   {t('finish_to_unlock')}
                </div>

                {/* Espaço extra GRANDE no final para empurrar a mensagem para cima da área de fade */}
                <div className="list-padding-bottom"></div>
            </>
            )}
        </div>
      </div>
    </div>
  );
}

export default LevelList;